import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import { ClimaProgramService } from '~/api/services/climaProgram'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface CompleteFeedPurchaseModalProps {
  purchaseId: number | null
  onClose: () => void
  onSuccess: () => void
}

const CompleteFeedPurchaseModal: React.FC<CompleteFeedPurchaseModalProps> = ({ purchaseId, onClose, onSuccess }) => {
  const { t } = useTranslation()
  const [isBusy, setIsBusy] = useState(false)

  async function handleConfirm() {
    setIsBusy(true)
    try {
      await ClimaProgramService.closePurchase(purchaseId)
      notify(t('Purchase completed successfully'), 'success')
      onSuccess()
      onClose()
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return (
    <Dialog
      type='abort'
      textHeader={t('Complete the food purchase')}
      textContent={t('Are you sure you want to complete this food purchase? Once confirmed, this purchase will be closed.')}
      isDialogOpen={Boolean(purchaseId)}
      handleClose={onClose}
      handleSubmit={handleConfirm}
      textSubmit={t('Complete the food purchase')}
      textClose={t('Cancel')}
      isLoading={isBusy}
    />
  )
}

export default CompleteFeedPurchaseModal
